enum CompanySubmissionState {
  PRE_START = "PRE_START",
  USER_FAILED_GENERIC = "USER_FAILED_GENERIC",
  USER_FAILED_DUPLICATE = "USER_FAILED_DUPLICATE",
}

export default CompanySubmissionState;
